import React from 'react'
import EmployeeSearch from '../../employee-search'
import type { DrawerProps } from './types'
import usePersonFilterSection from './usePersonFilterSection'

const PersonFilterSelection: React.FC<DrawerProps> = ({ persons }) => {
  const {
    areOptionsSelected,
    handleSelectAll,
    setSearchText,
    filteredPersonsList,
    onClick,
    currentSelectedPersons,
    searchText,
  } = usePersonFilterSection(persons)

  return (
    <EmployeeSearch
      onChange={(e) => setSearchText(e.target.value)}
      clearText={() => setSearchText('')}
      filteredPersonsList={filteredPersonsList}
      searchText={searchText}
      currentSelectedPersons={currentSelectedPersons}
      onClick={onClick}
      handleSelectAll={handleSelectAll}
      areOptionsSelected={areOptionsSelected}
    />
  )
}

export default PersonFilterSelection
